import React from 'react';
// import theme from 'theme';
// import { Grid, Typography } from '@material-ui/core';

const useStyles = {
  root: {
    // padding: theme.spacing(4)
  },
  content: {
    paddingTop: 150,
    textAlign: 'center'
  },
  image: {
    marginTop: 50,
    display: 'inline-block',
    maxWidth: '100%',
    width: 560
  }
};

const NotFound = () => {

  return (
    <div className={'useStyles.root'}>
      <div
        container
        justify="center"
        spacing={4}
      >
        <div
          item
          lg={6}
          xs={12}
        >
          <div className={'useStyles.content'}>
            <h1 variant="h1">
              404: The page you are looking for isn’t here
            </h1>
            <h1 className="subtitle2">
              You either tried some shady route or you came here by mistake.
              Whichever it is, try using the navigation
            </h1>
            <img
              alt="Under development"
              // className={useStyles.image}
               className='avatar-md'
              src="/images/undraw_page_not_found_su7k.svg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
